import { render, staticRenderFns } from "./managePublicExamQuestions.vue?vue&type=template&id=708a4c04"
import script from "./managePublicExamQuestions.vue?vue&type=script&lang=js"
export * from "./managePublicExamQuestions.vue?vue&type=script&lang=js"
import style0 from "./managePublicExamQuestions.vue?vue&type=style&index=0&id=708a4c04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports